import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export default class Placeholder extends React.PureComponent {
  static propTypes = {
    lines: PropTypes.number,
    allowBig: PropTypes.bool,
    onlyBig: PropTypes.bool,
    className: PropTypes.string,
  }

  static defaultProps = {
    lines: 12,
    allowBig: true,
    onlyBig: false,
  }

  get classNames() {
    const { className } = this.props;

    return classNames('ph-item', {
      [className]: className,
    });
  }

  render() {
    const { lines, allowBig, onlyBig } = this.props;
    const parts = [4, 6, 2, 8 , 10, 4, 12, 6, 10, 4, 8, 6];
    const lineArray = Array.apply(null, {length: lines}).map(Number.call, Number);

    return (
      <div className={this.classNames}>
      {
        lineArray.map((_, index) => {
          let size = parts[index % parts.length];
          let big = (allowBig && index % 4 === 0 || onlyBig) ? 'big' : '';
          return (
            <div className="ph-row" key={index}>
              <div className={ `ph-col-${size} ${big}`}>&nbsp;</div>
              <div className={ `ph-col-${12 - size} empty ${big}` }>&nbsp;</div>
            </div>
          )
        })
      }
      </div>
    )
  }
}
